import {
  BrandSubscriptionPaymentFrequency,
  BrandSubscriptionTier,
} from '@/utils/brand-subscription/constants'
import {Currency} from '@/utils/currency'
import {add} from '@/utils/pricing/decimals'
import {prices} from '@/utils/pricing/prices'

import {getTierBasePrice} from '../brand-subscription-payment/calculations'

export const getMinBrandMonitoringPriceByPaymentFrequency = (
  paymentFrequency: BrandSubscriptionPaymentFrequency,
  currency: Currency,
) =>
  Math.min(
    ...Object.values(BrandSubscriptionTier)
      .filter((tier) => tier.startsWith('v2'))
      .map((tier) => getTierBasePrice(paymentFrequency, tier, currency)),
  )

const calculateInfringementServiceTotalPrices = (currency: Currency) => {
  const serviceKeys = Object.keys({
    ...prices.enforcementServiceFees,
    ...prices.enforcementFilingFees,
  })

  const totalPricesByService = serviceKeys.reduce((acc: Record<string, number>, service) => {
    const serviceFee = prices.enforcementServiceFees[service]?.[currency] || 0
    const filingFee = prices.enforcementFilingFees[service]?.[currency] || 0
    acc[service] = add(serviceFee, filingFee)
    return acc
  }, {})

  return totalPricesByService
}

export const getMinInfringementServicePrice = (currency: Currency) => {
  const infringementPrices = calculateInfringementServiceTotalPrices(currency)
  return Math.min(...Object.values(infringementPrices))
}
